<script setup lang="ts">
import type { CmsElementHeadlineTextButtonBackground } from "~/composables/useCustom";

// Define props with validation
const props = defineProps<{
  content: CmsElementHeadlineTextButtonBackground;
}>();

// Destructure data for cleaner access
const { bgImage, headlineText, mainText, button } = props.content.data;

// Update computed properties to use destructured values
const backgroundStyle = computed(() => ({
  backgroundImage: `url('${bgImage.media.url || ""}')`,
}));
</script>

<template>
  <div
    class="cust-sec-1 relative bg-red-bg bg-cover bg-center px-4"
    :style="backgroundStyle"
    role="region"
    :aria-label="headlineText"
  >
    <div class="absolute inset-0 bg-red-bg opacity-30" aria-hidden="true"></div>
    <div
      class="container mx-auto relative z-10 flex flex-col md:flex-row items-center py-12 md:py-20"
    >
      <div class="wrap flex flex-col md:flex-row items-center justify-between w-full">
        <!-- Content Section -->
        <div
          class="text-left max-w-full w-full md:w-[calc(100%-400px)] mb-8 md:mb-0 text-white"
        >
          <h2 v-if="headlineText" class="h2-font">
            {{ headlineText }}
          </h2>
          <div
            v-if="mainText"
            class="para"
            v-html="mainText"
            :aria-label="mainText?.replace(/<[^>]*>/g, '') || undefined"
          />
        </div>

        <!-- CTA Button -->
        <div class="text-left md:text-right w-full md:w-auto">
          <SharedButton v-if="button" :button="button" class="btn-white-bg btn-default">
          </SharedButton>
        </div>
      </div>
    </div>
  </div>
</template>
